import { render, staticRenderFns } from "./DOHPage.vue?vue&type=template&id=67899e3c&scoped=true"
import script from "./DOHPage.vue?vue&type=script&lang=js"
export * from "./DOHPage.vue?vue&type=script&lang=js"
import style0 from "./DOHPage.vue?vue&type=style&index=0&id=67899e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67899e3c",
  null
  
)

export default component.exports